/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoGrantUpdate } from '../../models/dto-grant-update';
import { GrantItem } from '../../models/grant-item';

export interface GrantControllerUpdate$Params {
  id: number;
      body: DtoGrantUpdate
}

export function grantControllerUpdate(http: HttpClient, rootUrl: string, params: GrantControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>> {
  const rb = new RequestBuilder(rootUrl, grantControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GrantItem;
      }>;
    })
  );
}

grantControllerUpdate.PATH = '/grant/{id}';
